import React, { useEffect, useRef } from "react";
import { useStore } from '../store/store';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { Button } from 'primereact/button';
import { LogLineGenerator } from './setup/LogLineGenerator';
import { Details } from './setup/Details';
import { CharacterCreation } from './setup/CharacterCreation';
import api from '../services/api';
import { LocationCreation } from './setup/LocationCreation';
import { LoreItemCreation } from './setup/LoreItemCreation';
import { useNavigate } from 'react-router-dom';
import { ChapterCreation } from './setup/ChapterCreation';


export const CreateFiction = () =>  {
    const [state, actions] = useStore();
    const stepperRef = useRef(null);
    const [logline, setLogline] = React.useState(null);
    const [title, setTitle] = React.useState('');
    const [tone, setTone] = React.useState('');
    const [innerMonologue, setInnerMonologue] = React.useState('yes');
    const [dialogue, setDialogue] = React.useState('normal');
    const [characters, setCharacters] = React.useState([]);
    const [locations, setLocations] = React.useState([]);
    const [loreItems, setLoreItems] = React.useState([]); // Add state for lore items
    const [novelId, setNovelId] = React.useState(null);
    const navigate = useNavigate();

    const saveCharacters = async () => {
        await api.saveCharacters(novelId, characters);
    }

    const saveLocations = async () => {
        locations.map(async location => {
            await api.createLocation(novelId, location);
        });
    }

    const saveLoreItems = async () => {
        loreItems.map(async loreItem => {
            await api.createLoreItem(novelId, loreItem);
        });
    }

    useEffect(() => {
        if (state.readOnly) {
            navigate('/dashboard');
        }
    }
    , []);

    return (
        <div style={{margin: '0 auto', width: '75%'}}>
            <div className="card flex justify-content-center">
                <Stepper linear ref={stepperRef} style={{ flexBasis: '50rem' }}>
                    <StepperPanel header="Logline">
                        <div className="flex flex-column h-12rem">
                            <LogLineGenerator setLogline={setLogline}/>
                        </div>
                        {logline !== null && logline !== '' ?
                        <div className="flex pt-4 justify-content-end">
                            <Button label="Next" icon="pi pi-arrow-right" iconPos="right" onClick={() => stepperRef.current.nextCallback()} />
                        </div> : null}
                    </StepperPanel>
                    <StepperPanel header="Details">
                        <div className="flex flex-column h-12rem">
                            <Details setTitle={setTitle} logline={logline} setTone={setTone} setInnerMonologue={setInnerMonologue} setDialogue={setDialogue} tone={tone} innerMonologue={innerMonologue} dialogue={dialogue}/>
                        </div>
                        <div className="flex pt-4 justify-content-between">
                            <Button label="Next" icon="pi pi-arrow-right" iconPos="right" onClick={async () => {
                                const novel = await api.createNovel({
                                    title: title,
                                    type: 'fiction',
                                    logline: logline,
                                    writingPreferences: {
                                        tone: tone,
                                        innerMonologue: innerMonologue,
                                        directSpeech: dialogue
                                    }
                                });
                                setNovelId(novel.novelId);
                                stepperRef.current.nextCallback();
                            }} />
                        </div>
                    </StepperPanel>
                    <StepperPanel header="Characters">
                        <div className="flex flex-column h-12rem">
                            <CharacterCreation characters={characters} setCharacters={setCharacters} novelId={novelId}/>
                        </div>
                        <div className="flex pt-4 justify-content-start">
                        <Button label="Next" icon="pi pi-arrow-right" iconPos="right" onClick={() => {saveCharacters(); stepperRef.current.nextCallback();}} />
                        </div>
                    </StepperPanel>
                    <StepperPanel header="Locations">
                        <div className="flex flex-column h-12rem">
                            <LocationCreation locations={locations} setLocations={setLocations} novelId={novelId} />
                        </div>
                        <div className="flex pt-4 justify-content-start">
                        <Button label="Next" icon="pi pi-arrow-right" iconPos="right" onClick={() => {saveLocations(); stepperRef.current.nextCallback();}} />
                        </div>
                    </StepperPanel>
                    <StepperPanel header="Lore">
                        <div className="flex flex-column h-12rem">
                            <LoreItemCreation loreItems={loreItems} setLoreItems={setLoreItems} novelId={novelId} />
                        </div>
                        <div className="flex pt-4 justify-content-start">
                        <Button label="Next" icon="pi pi-arrow-right" iconPos="right" onClick={() => {saveLoreItems(); stepperRef.current.nextCallback();}} />
                        </div>
                    </StepperPanel>
                    <StepperPanel header="Chapters">
                        <div className="flex flex-column h-12rem">
                            <ChapterCreation novelId={novelId} />
                        </div>
                        <div className="flex pt-4 justify-content-start">
                        </div>
                    </StepperPanel>
                </Stepper>
            </div>
        </div>
    )
}

export default CreateFiction;